"use client";

import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { useRouter } from "next/navigation";
import { useTranslations } from "next-intl";

export function ProjectBackButton() {
    const t = useTranslations("projects.detail");
    const router = useRouter();

    return (
        <Button variant="ghost" size="sm" className="gap-2" onClick={() => router.back()}>
            <ArrowLeft className="h-4 w-4" />
            {t("back")}
        </Button>
    );
}
